import NetworkNotGood from './NetworkNotGood';

const NetworkWarning = () => {
  const explanationText =
    'Our test has identified potential connection issues that may affect your call quality. To ensure a smooth communication experience, try these tips:';

  return <NetworkNotGood explanationText={explanationText} />;
};

export default NetworkWarning;
